import * as CONST from "../const/action.const";

const initialState = {
  detail: "",
};
export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  console.log(
    "You are in dispatch, the type is: ",
    type,
    " - the payload is: ",
    payload
  );
  switch (type) {
    case CONST.SET_MESSAGE:
      return {
        ...state,
        detail: payload,
      };
    case CONST.CLEAR_MESSAGE:
      return { ...state, detail: "" };
    case CONST.GET_MESSAGE:
      console.log("state", state);
      return state;
    default:
      return state;
  }
}
